import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatInput, MatLabel } from '@angular/material/input';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';
import { MatTooltip } from '@angular/material/tooltip';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatFormField } from '@angular/material/form-field';
import { MatFormFieldClass } from '../../input.types';

@Component({
  selector: 'coin-v2-text-area',
  templateUrl: './v2-text-area.component.html',
  styleUrls: ['./v2-text-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatInput, FormsModule, MatIconModule, MatTooltip, MatFormField, MatLabel, TextFieldModule]
})
export class V2TextAreaComponent extends DefaultFormValueControl<string> {
  readonly label = input<string>();
  readonly placeholder = input<string>();
  readonly icon = input<string>();
  readonly rows = input<number | 'auto'>('auto');
  readonly matFormFieldClass = input<MatFormFieldClass>('customer-grey');

  // the CDK autosize forces several layouts per textarea; it stays as fallback for browsers without field-sizing (Safari < 26.2)
  protected readonly sizesToContent = CSS.supports('field-sizing', 'content');
}
